import personalInfo from "./PersonalInfo";

const profileData = {
    personalInfo: personalInfo,
    socialMedia: [

    ],
    education: [

    ],
    projects: {

    },
    certifications: [

    ],
    skills: {
        techSkills: [

        ],
        nonTechSkills: [

        ]
    },
    tools: [

    ]

}

export default profileData;